export const navigateTo = (route, type = "app") => {
  const params = new URLSearchParams(window.location.search);
  const via = params.get("via");
  const ref = params.get("ref");

  const base =
    type === "app" ? "https://v2.frontly.ai" : "https://www.frontly.ai";

  if (ref && ref !== "null" && via && via !== "null") {
    // VIA AND REF
    window.location.href = `${base}/${route}?via=${via}&ref=${ref}`;
  } else if (ref && ref !== "null") {
    // REF ONLY
    window.location.href = `${base}/${route}?ref=${ref}`;
  } else if (via && via !== "null") {
    // VIA ONLY
    window.location.href = `${base}/${route}?via=${via}`;
  } else {
    // NONE
    window.location.href = `${base}/${route}`;
  }
};
